module.exports = __webpack_public_path__ + "media/images/general/redash_icon_small-6396f831506163ca50fb29a0561ca83f.png";